export default class VendorModel {
  VendorId: number | null;
  VendorName: string;
  VendorLogo: string;
  Address: string;
  ContactNumber: string;
  Email: string;
  Website: string;
  Rating: number | null;
  ReviewCount: number;
  IsActive: boolean;

  constructor() {
    this.VendorId = null;
    this.VendorName = '';
    this.VendorLogo = '';
    this.Address = '';
    this.ContactNumber = '';
    this.Email = '';
    this.Website = '';
    this.Rating = null;
    this.ReviewCount = 0;
    this.IsActive = true;
  }
}
